import { render, staticRenderFns } from "./before-page.vue?vue&type=template&id=49f0b11c&scoped=true&"
import script from "./before-page.vue?vue&type=script&lang=js&"
export * from "./before-page.vue?vue&type=script&lang=js&"
import style0 from "./before-page.vue?vue&type=style&index=0&id=49f0b11c&scoped=true&lang=less&"
import style1 from "./before-page.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f0b11c",
  null
  
)

export default component.exports